import { isEmpty } from 'lodash'
import { AsyncValidateCallback } from 'redux-form'
import { isDate } from 'date-fns'
import { IGuestInfo } from '../../../models/Event'
import { validEmail } from '../../../utils/Validation'
import { ISettingsFormValues } from '../Settings/SettingsForm'
import validateReservation from '../../../actions/bookingCalendar/reservationModal/validateReservationForm'
import i18n from '../../../i18n'
import store from '../../../store'
import fireToastError from '../../../actions/toasts/fireToastError'
import { ICreateReservationFormValues } from './CreateReservation'
import { Mixpanel } from '../../../utils/Mixpanel'

export type Errors = {
  [K in keyof Omit<ICreateReservationFormValues, 'guest'>]: string
} & {
  guest?: {
    [K in keyof IGuestInfo]: string
  }
}

export default function() {
  return function(
    values: ICreateReservationFormValues,
    dispatch,
  ): Promise<Errors> {
    return new Promise((resolve, reject) => {
      const { roomId, adultsCount, dateTo, guest } = values
      const errors: Errors = {}
      const errorTabs = new Set<number>()
      if (!roomId || isEmpty(roomId)) {
        errors.roomId = i18n.t('BBO_963_select_room')
        errorTabs.add(0)
      }
      if (!adultsCount || adultsCount === 0) {
        errors.adultsCount = i18n.t('reservation_error_wrong_number_of_people')
        errorTabs.add(0)
      }
      if (!isEmpty(guest.email) && !validEmail(guest.email)) {
        errors.guest = {
          email: i18n.t('reg_error_email_not_email'),
        }
        errorTabs.add(1)
      }
      if (!isDate(dateTo)) {
        errors.dateTo = i18n.t('reservation_no_date_error')
        store.dispatch(
          fireToastError(
            i18n.t('z677_date_to_not_empty'),
            null,
            'Event',
            'reservationDateEmptyError',
          ),
        )
        errorTabs.add(0)
      }

      if (isEmpty(errors)) {
        resolve({} as any)
      } else {
        if (errors.adultsCount && !errors.dateTo) {
          store.dispatch(
            fireToastError(
              i18n.t('reservation_error_wrong_number_of_people'),
              null,
              'Event',
              'reservationPeopleNumberError',
            ),
          )
        } else if (
          errors &&
          errors.roomId &&
          !(errors.dateTo || errors.adultsCount)
        ) {
          store.dispatch(
            fireToastError(
              i18n.t('BBO_963_select_room'),
              null,
              'Event',
              'reservationNoRoomError',
            ),
          )
        }
        dispatch(validateReservation([...errorTabs]))
        reject(errors)
        Mixpanel.track('Reservation Form Validation', {
          'Reservation ID': Number(values.id),
        })
      }
    })
  }
}

export function shouldAsyncValidate(
  params: AsyncValidateCallback<ISettingsFormValues, string>,
): boolean {
  return params.trigger === 'submit' && params.trigger !== undefined
}
